export const preloader = () => {
    window.addEventListener('load', function() {

        var overlay = document.querySelector('.preloader');

        overlay.style.opacity = 0;
    
        // Optional: Remove the overlay from the DOM after the transition
        overlay.addEventListener('transitionend', function() {
            overlay.style.display = 'none';
        });
    });
    
 
 }
 